module.exports = __webpack_public_path__ + "img/nomad.1c0945d1.webp";